import type {IObserver} from '@/common/scripts/types/observer';
import Observer from '@/common/scripts/observer';

const observer: IObserver = new Observer();


const changeHeaderFavorite = (wrapper: HTMLElement): void => {
    if (!wrapper) {
        return;
    }

    observer.subscribe('premisesFavorite', (value: number | null): void => {
        const favoriteNum: string | number = wrapper.innerHTML.toString().trim();
        const quantity = value || favoriteNum;

        wrapper.innerText = Number(quantity) <= 9 ? quantity.toString() : '9+';
    });
};

export default changeHeaderFavorite;
